import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material';
import { PaymentTransactionDTO } from 'src/app/core/model/v2/PaymentTransactionDTO';
import { PageRequestInterface } from 'src/app/core/models/PageRequestInterface';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-employer-payment-history',
  templateUrl: './employer-payment-history.component.html',
  styleUrls: ['./employer-payment-history.component.scss']
})
export class EmployerPaymentHistoryComponent implements OnInit {

  pageSize = 10;
  page = 1;
  totalRecords = 0;
  displayedColumns: string[] = ['date', 'status', 'amount', 'receipt'];
  payments: PaymentTransactionDTO[];
  constructor(private practiceService: PracticeService, private loaderService: WindowLoaderService) { }

  ngOnInit() {
    this.LoadPayments();
  }

  private LoadPayments() {

    this.loaderService.show();
    this.practiceService.getHealthOrganizationPayments(this.page, this.pageSize).subscribe(
      (hoPaymentsPage) => {
        this.payments = hoPaymentsPage.pageItems;
        this.totalRecords = hoPaymentsPage.totalRecords;
      },
      (error) => { console.error(error); this.loaderService.hide(); },
      () => { this.loaderService.hide(); }
    );
  }

  changeIndex(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.page = event.pageIndex + 1;
    this.LoadPayments();
  }

}
